import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 6V4H2v3h12V4h-2v2h-2V4H6v2H4zm10 3H2v5h12V9zM2 2h2V0h2v2h4V0h2v2h4v14H0V2h2z",
		fill: "currentColor"
	})
});
export default SvgCalendar;
